import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';

export default function ConfirmModal({
  isOpen,
  onClose,
  handleConfirm,
  isLoading,
  AreYouSureQuestion,
  AreYouSureTextExplanation,
  confirmButtonText,
  confirmButtonColor,
  colorScheme,
}: any) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{AreYouSureQuestion}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{AreYouSureTextExplanation}</ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={colorScheme}
            bg={confirmButtonColor}
            isLoading={isLoading}
            onClick={handleConfirm}
          >
            {confirmButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
